export default __webpack_public_path__ + "static/media/launched-ship.084dc7d1.png";